// apiとformの日付フォーマットを変換する

export const convertApiDateToFormDate = (apiDate?: string | null) => {
  // falsyの場合
  if (!apiDate) {
    return apiDate;
  }

  return apiDate.replaceAll('/', '-');
};

export const convertFormDateToApiDate = (formDate?: string | null) => {
  // formに入力がない場合はnullを返す
  if (formDate === '') {
    return null;
  }

  // 上記以外のfalsy
  if (!formDate) {
    return formDate;
  }

  return formDate.replaceAll('-', '/');
};
